import type { Experience } from './experience'
import { clearContactAuthStorage } from './contactAuthTokenStorage'

export { clearContactAuthStorage }

const API_TOKEN_STORAGE_KEY = 'api_Token'

function readStringField(payload: Record<string, unknown>, key: string): string | undefined {
  const v = payload[key]
  return typeof v === 'string' ? v : undefined
}

function readUiConfigPhone(payload: Record<string, unknown>): string | undefined {
  const uiConfig = payload.uiConfig
  if (typeof uiConfig !== 'object' || uiConfig === null || Array.isArray(uiConfig)) {
    return undefined
  }
  const phone = (uiConfig as Record<string, unknown>).centralStationPhone
  return typeof phone === 'string' ? phone : undefined
}

function readUiConfigFaq(payload: Record<string, unknown>): string | undefined {
  const uiConfig = payload.uiConfig
  if (typeof uiConfig !== 'object' || uiConfig === null || Array.isArray(uiConfig)) {
    return undefined
  }
  const faq = (uiConfig as Record<string, unknown>).webFAQLink
  return typeof faq === 'string' ? faq : undefined
}

export function persistContactAuthToken(
  smartAuth: string,
  jwtPayload: Record<string, unknown> | null,
  experience: Experience,
): void {
  try {
    sessionStorage.setItem(API_TOKEN_STORAGE_KEY, smartAuth)
    if (!jwtPayload) return
    const tenantId = readStringField(jwtPayload, 'tenantId') ?? 'adt-res'
    const avs01 = jwtPayload.avs01 === true
    sessionStorage.setItem('tenant_id', tenantId)
    sessionStorage.setItem('avs01', String(avs01))
    if (experience !== 'legacy') return
    sessionStorage.setItem(
      'central_station_phone',
      readUiConfigPhone(jwtPayload) ?? '8002382727',
    )
    sessionStorage.setItem(
      'web_faq_link',
      readUiConfigFaq(jwtPayload) ??
        'https://help.adt.com/s/article/Alarm-MessengerTM-FAQs',
    )
  } catch {
    return
  }
}
